import { render, staticRenderFns } from "./associationAdd.vue?vue&type=template&id=11f6fd2b&scoped=true&"
import script from "./associationAdd.vue?vue&type=script&lang=js&"
export * from "./associationAdd.vue?vue&type=script&lang=js&"
import style0 from "./associationAdd.vue?vue&type=style&index=0&id=11f6fd2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6fd2b",
  null
  
)

export default component.exports